module.exports = __webpack_public_path__ + "img/main_wallet_bg01.788d0f84.png";